import React, { createContext, useState, ReactNode } from 'react';
import { Service, Client, Session } from '../types';

interface AppState {
  selectedProblem: string | null;
  setSelectedProblem: (problem: string | null) => void;
  recommendedService: Service | null;
  setRecommendedService: (service: Service | null) => void;
  selectedService: Service | null;
  setSelectedService: (service: Service | null) => void;
  clientInfo: Client | null;
  setClientInfo: (info: Client | null) => void;
  currentSession: Session | null;
  setCurrentSession: (session: Session | null) => void;
}

export const AppContext = createContext<AppState | undefined>(undefined);

export const AppProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [selectedProblem, setSelectedProblem] = useState<string | null>(null);
  const [recommendedService, setRecommendedService] = useState<Service | null>(null);
  const [selectedService, setSelectedService] = useState<Service | null>(null);
  const [clientInfo, setClientInfo] = useState<Client | null>(null);
  const [currentSession, setCurrentSession] = useState<Session | null>(null);

  return (
    <AppContext.Provider value={{
      selectedProblem, setSelectedProblem,
      recommendedService, setRecommendedService,
      selectedService, setSelectedService,
      clientInfo, setClientInfo,
      currentSession, setCurrentSession
    }}>
      {children}
    </AppContext.Provider>
  );
};
